import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/BrandLeaderBoardSagas";

const MetricsFilter = () => {
  const dispatch = useDispatch();
  const metrics = useSelector((state) => state.brandLeaderboard.metrics);
  const selectedMetrics = useSelector((state) => state.brandLeaderboard.selectedMetrics);

  return (
    <MultiSelectDropdown
      options={metrics}
      selectedFilters={selectedMetrics}
      enableOnly
      numberDisplayed={0}
      includeSelectAll
      haveOnSelectChange
      onSelectChange={(data) => dispatch(actionCreators.updateSelectedMetricsFilter(data))}
    />
  );
};

export default MetricsFilter;
